<template>
  <section class="container">
    <div class="error">
      <div class="error__left">
        <p class="error__icon" data-title="ERROR">
          <span>ERROR</span>
        </p>
      </div>

      <div class="error__right">
        <p class="error__text">
          {{ $t('error.message.contactAdmin') }}<br />
          <a href="https://ifconfig.me/" target="_blank">
            {{ $t('error.link.checkIP') }}
          </a>
        </p>

        <router-link class="error__button" to="/">
          {{ $t('common.button.returnHome') }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    const temp = new Date();
    const d = new Date(temp.setDate(temp.getDate() - 1));
    document.cookie = `token=;expires=${d}; path=/`;
    document.cookie = `CloudFront-Policy=; expires=${d}; path=/`;
    document.cookie = `CloudFront-Key-Pair-Id=; expires=${d}; path=/`;
    document.cookie = `CloudFront-Signature=; expires=${d}; path=/`;
    this.$setUserAccount();
  },
};
</script>

<style lang="scss" scoped>
</style>
